
import { WorldCountry } from '../types';
import { indonesiaExpanded4 } from './indonesiaExpansion4';
import { philippinesExpanded4 } from './philippinesExpansion4';
import { vietnamExpanded2 } from './vietnamExpansion2';

// Expansión Fase 11 - Indonesia, Filipinas y Vietnam con 100+ ciudades cada uno
export const asiaExpansion11: WorldCountry[] = [
  indonesiaExpanded4,
  philippinesExpanded4,
  vietnamExpanded2
];
